import { Link } from 'react-router-dom'

const Nav = () => {
  

  return (
    <div className='container'>
      <nav className='navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white'>
       
      </nav>
    </div>
  )
}

export default Nav
